// RatingContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL } from '../config/config';

const RatingContext = createContext();

export const RatingProvider = ({ productId, children }) => {
  const [ratingData, setRatingData] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRatings() {
      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/get-rating/${productId}`);
        //if (!res.ok) throw new Error('Failed to fetch ratings');
        const data = await res.json();

        const breakdown = data.ratings_breakdown;
        const formattedData = Object.entries(breakdown)
          .sort((a, b) => b[0] - a[0])
          .map(([stars, val]) => ({
            stars: parseInt(stars),
            count: val.count,
            percentage: val.percentage,
          }));

        setRatingData(formattedData);
        setAverageRating(data.average_rating);
        setTotalReviews(data.total_reviews);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    }

    if (productId) {
      fetchRatings();
    }
  }, [productId]);

  return (
    <RatingContext.Provider value={{ ratingData, averageRating, totalReviews, loading, error }}>
      {children}
    </RatingContext.Provider>
  );
};

// Custom hook to use the context
export const useRating = () => useContext(RatingContext);
